// Questionnaire card for the calendar sidebar "phone" preview (formType 'Questions').
// Copy of the workouts module's Questionnaire — maps questions to CalendarQuestion and shows
// the total footer when enabled.
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import CalendarQuestion from './CalendarQuestion';
import CalendarQuestionnaireTotal from './CalendarQuestionnaireTotal';

const Container = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
`;

const CalendarQuestionnaire = ({ workoutObject }) => (
  <Container>
    {workoutObject?.questions?.map((question, idx) => (
      <CalendarQuestion
        key={question.id}
        question={question}
        first={idx === 0}
      />
    ))}
    <div />
    {workoutObject.questionnaireTotalEnabled ? (
      <CalendarQuestionnaireTotal workoutObject={workoutObject} />
    ) : null}
  </Container>
);

CalendarQuestionnaire.propTypes = {
  workoutObject: PropTypes.instanceOf(Object).isRequired,
};

export default CalendarQuestionnaire;
